import React, { useState } from 'react'
import { getQuestions } from './questions'
import Button from '../../../shared/components/atoms/button/button'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'
import './sectionLearnMore.scss'

const SectionLearnMore = () => {
  const [activeTabs, setActiveTabs] = useState([])
  const [page, setPage] = useState(1)

  const handleActiveTabs = tab => {
    const tabs = activeTabs
    const isOpen = activeTabs.findIndex(i => i === tab)
    if (isOpen === -1) {
      tabs.push(tab)
    } else {
      tabs.splice(isOpen, 1)
    }
    setActiveTabs([...tabs])
  }

  const articlesView = 5

  const handleLoadMore = () => {
    if (page < getQuestions().length / articlesView) {
      setPage(page + 1)
    }
  }

  const onDatalayer = item => {
    pushEventDataLayer({
      event: 'Interacciones - Preguntas Frecuentes',
      category: 'embajadoras-curv',
      action: 'click',
      label: item,
      location: 'nosotras.com/embajadoras',
    })
  }

  return (
    <section className="f-frequently-questions">
      <div className="f-frequently-questions__wrapper">
        <h2 className="f-frequently-questions__title">Aprende más</h2>
        <p className="f-frequently-questions__subtitle">
          Conviértete en una experta y mejora tu contenido en cada reto
        </p>
        <div className="f-frequently-questions__container">
          {getQuestions().map((preguntaFrecuente, i) => {
            if (i < page * articlesView) {
              return (
                <div
                  onClick={() => {
                    handleActiveTabs(i)
                    onDatalayer(preguntaFrecuente.questions)
                  }}
                  className="f-frequently-questions__container__question"
                  key={`questionMob-${i}`}
                >
                  <span
                    className={`f-frequently-questions__container__question-arrow ${
                      activeTabs.includes(i) ? 'active' : ''
                    }`}
                  />
                  <b className={`${activeTabs.includes(i) ? 'active' : ''}`}>
                    {preguntaFrecuente.questions}
                  </b>
                  <div className={`${activeTabs.includes(i) ? 'active' : ''}`}>
                    {preguntaFrecuente.answer}
                  </div>
                </div>
              )
            }
          })}
        </div>

        {articlesView * page < getQuestions().length && (
          <div className="f-frequently-questions__btn">
            <Button
              title="Ver más preguntas"
              className="new-dark-blue"
              onClick={handleLoadMore}
            />
          </div>
        )}
      </div>
    </section>
  )
}

export default SectionLearnMore
